import { ArrowUpRight, ImageIcon } from "lucide-react";
import type { PortfolioProject } from "@/hooks/usePortfolio";

interface Props {
  project: PortfolioProject;
  categoryName?: string;
  index: number;
  onOpen: () => void;
}

const layoutClasses = [
  "lg:mt-0",
  "lg:mt-12",
  "lg:mt-24",
  "lg:mt-0",
  "lg:mt-12",
  "lg:mt-24",
];

const frameClasses = [
  "aspect-[4/5]",
  "aspect-[4/5]",
  "aspect-[4/5]",
  "aspect-[4/5]",
  "aspect-[4/5]",
  "aspect-[4/5]",
];

const FeaturedShowcaseCard = ({ project, categoryName, index, onOpen }: Props) => {
  const position = index % layoutClasses.length;

  return (
    <article className={`featured-work-reveal ${layoutClasses[position]}`} data-reveal-index={position}>
      <button
        type="button"
        onClick={onOpen}
        className="featured-work-card group block w-full text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background"
        aria-label={`View case study for ${project.title}`}
      >
        <span className={`featured-work-frame relative block overflow-hidden rounded-md border border-border bg-card ${frameClasses[position]}`}>
          {project.image_url ? (
            <img
              src={project.image_url}
              alt={`${project.title} screenshot`}
              loading="lazy"
              width={1200}
              height={750}
              className="featured-work-image h-full w-full object-cover object-top opacity-80"
            />
          ) : (
            <span className="featured-work-placeholder flex h-full w-full items-center justify-center text-muted-foreground">
              <ImageIcon className="h-12 w-12" aria-hidden="true" />
            </span>
          )}
          <span className="featured-work-wash absolute inset-0" aria-hidden="true" />
          <span className="absolute inset-x-0 bottom-0 z-10 p-5 sm:p-7">
            <span className="mb-3 block text-[11px] font-bold uppercase text-primary">{categoryName ?? "Digital project"}</span>
            <span className="flex items-end justify-between gap-4">
              <span className="min-w-0 font-display text-2xl font-bold leading-tight text-foreground sm:text-3xl">
                {project.title}
              </span>
              <span className="featured-work-arrow flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-foreground/20 bg-background/80 text-foreground backdrop-blur">
                <ArrowUpRight className="h-5 w-5" aria-hidden="true" />
              </span>
            </span>
            <span className="featured-work-rule mt-4 block h-0.5 w-12 bg-primary" aria-hidden="true" />
          </span>
        </span>
        <span className="featured-work-card-copy block px-1 pt-4">
          {project.summary && <span className="block text-sm leading-relaxed text-muted-foreground">{project.summary}</span>}
        </span>
      </button>
    </article>
  );
};

export default FeaturedShowcaseCard;